
import { mdiArrowLeft, mdiArrowRight, mdiContentSave, mdiClose } from '@mdi/js'
export default {
  props: {
    showStepper: Boolean,
    steps: Array,
  },
  data() {
    return {
      media: [],
      index: null,
      stepperStep: 1,
      mdiArrowLeft,
      mdiArrowRight,
      mdiContentSave,
      mdiClose,
    }
  },
  computed: {
    textboxRules() {
      const rules = []
      let rule
    }, //TODO: implement 10 character count rule
  },
  methods: {
    closeAndCancelCustomization(){
      const c = confirm('This will remove all text entered and detach layout customization from current product customization. Do you wish to continue?')
      if(!c) return;
      this.$emit('closeAndCancelCustomization')
    },
    review(){
      this.stepperStep = 1;
    },
    closeLightBox() {
      this.showLightBoxOnDom = false
      this.index = null
    },
    async showZoomedImage(image) {
      try {
        this.generateLightBoxImages(image)
        await this.$nextTick()
        this.showLightBoxOnDom = true
        this.index = 0
      } catch (error) {
        console.error(error)
      }
    },
    generateLightBoxImages(image) {
      try {
        if (!image)
          this.media = [
            {
              // For image
              thumb: '',
              src: '',
              caption: 'Product image', // Optional - supports HTML
              // srcset: '...' // Optional for displaying responsive images
            },
          ]
        this.media = [
          {
            thumb: image,
            src: image,
            caption: 'Product image', // Optional - supports HTML
            // srcset: '...' // Optional for displaying responsive images
          },
        ]
      } catch (error) {
        console.error(error)
      }
    },
    nextStep() {
      if (this.stepperStep === this.steps.length + 1)
        return (this.stepperStep = 1)
      this.stepperStep = this.stepperStep + 1
    },
    prevStep() {
      if (this.stepperStep === 1)
        return (this.stepperStep = this.steps.length + 1)
      this.stepperStep = this.stepperStep - 1
    },
    saveCustomization() {
      this.$emit('saveCustomization')
    },
  },
}
